import React, { useState } from "react";
import "../../styles/ContactUs.css";
import useSEO from "../../hooks/useSeo";

function ContactUs() {
  useSEO({
    title: "Contact Us | Priyadharshinie Public School, Bengaluru",
    description:
      "Contact Priyadharshinie Public School in Chikkasandra, Bengaluru. Phone number, address, and admission enquiries available here.",
    url: "https://www.priyadharshiniepublicschool.in/contact-us",
  });

  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setForm({ name: "", email: "", message: "" });

    setTimeout(() => setSubmitted(false), 4000);
  };

  return (
    <div className="contact-container">
      <h1 className="contact-title">Contact Us</h1>
      <p className="contact-subtitle">
        Have questions? Reach out to us via phone, email, or WhatsApp.
      </p>

      {/* Contact Details */}
      <div className="contact-details">
        <div>
          <h3>📞 Phone</h3>
          <a href="tel:+919620875447" className="contact-link">
            +91 96208 75447
          </a>
        </div>

        <div>
          <h3>📧 Email</h3>
          <a href="mailto:priya.dharshinie123@gmail.com" className="email-link">
            priya.dharshinie123@gmail.com
          </a>
        </div>

        <div>
          <h3>💬 WhatsApp</h3>
          <a
            href="https://wa.me/919620875447?text=I%20want%20to%20know%20more%20about%20your%20school"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-link"
          >
            Chat on WhatsApp
          </a>
        </div>
      </div>

      {/* Contact Form */}
      <form onSubmit={handleSubmit} className="contact-form">
        <label>
          <span className="sr-only">Your Name</span>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          <span className="sr-only">Your Email</span>
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          <span className="sr-only">Your Message</span>
          <textarea
            name="message"
            placeholder="Your Message"
            value={form.message}
            onChange={handleChange}
            rows="5"
            required
          />
        </label>

        <button type="submit">Send Message</button>

        {submitted && (
          <p className="form-success">
            ✅ Thank you! We will contact you shortly.
          </p>
        )}
      </form>

      {/* Google Map */}
      <div className="map-container">
        <iframe
          title="Priyadharshinie Public School Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.5310962226754!2d77.50402707412192!3d13.065491712814728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae232526d664ff%3A0xb86b2e6cf42914bc!2sPriyadharshinie%20Public%20School!5e0!3m2!1sen!2sin!4v1757532078919!5m2!1sen!2sin"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
}

export default ContactUs;
